import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';

/**
 * react-maskedinput uses custom actions _onChange, _onKeyDown, _onPaste, _onKeyPress
 * and doesnt allow external functions for this.
 * as a result, custom date-picker events on keydown do not work
 */
class CustomDatePickerInput extends Component {
  inputRef = React.createRef();

  onKeyDownHackHandle = (e) => {
    if (e.key === 'Enter') {
      e.stopPropagation();
    }
    this.props.onKeyDown(e);
  };
  onBlur = (e) => {
    // it needs because mask value update only if value changed, but DatePicker prevent update if value is invalid date
    this.inputRef.current.mask.setValue(this.props.value);
    this.props.onBlur(e);
  };
  render() {
    return (
      <div onKeyDown={this.onKeyDownHackHandle}>
        <MaskedInput ref={this.inputRef} {...this.props} onBlur={this.onBlur} />
      </div>
    );
  }
}
CustomDatePickerInput.propTypes = {
  onKeyDown: PropTypes.func,
  value: PropTypes.string,
  onBlur: PropTypes.func,
};
export default CustomDatePickerInput;
